<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <app-note
          :title="$t('note')"
          note-type="note-warning"
          :notes="[notes.notes]"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import { JOB_NOTES } from "../../../../../../Config/ApiUrl.js";
import { axiosGet } from "../../../../../../Helpers/AxiosHelper.js";

export default {
  name: "Notes",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      notes: {},
    };
  },
  methods: {
    getNotes() {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      
      // let id = split[7].split("?")[0];
      let id = this.$attrs['props'].id;
      axiosGet(JOB_NOTES + "/" + id)
        .then((res) => {
          this.notes = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getNotes();
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
